import * as React from 'react'
import { Alert, Button, Modal } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { IndividualLicenseCheck } from 'api/common/constants'
import { trustdockBrowserSdk } from 'api/external/trustdock'
import { identificationRegisterForIndividualAPI } from 'api/identification'
import Footer from 'components/Footer'
import Header from 'components/Header'
import loginData from 'utilities/loginData'
import { getIndividualLicenseCheckMessage } from 'utilities/resources/options'

const SceneComponent: React.FC = () => {
  const navigate = useNavigate()
  const acceptedStatus = React.useMemo(() => loginData.getIdentificationRegistrationStatus(), [])
  const [enterSucceeded, setEnterSucceeded] = React.useState(false)
  const [modal, setModal] = React.useState<{ show: boolean; message?: string }>({ show: false })
  React.useEffect(() => {
    if (!loginData.isLoggedIn()) {
      navigate('/')
    }
  }, [navigate])

  /**
   * 「本人確認書類を撮影する」ボタン
   */
  const handleStartAuthButton = async () => {
    const verificationId = await trustdockBrowserSdk()
    if (verificationId) {
      identificationRegisterForIndividualAPI({ verificationId }, (result) => {
        const valid = result === IndividualLicenseCheck.Valid
        setEnterSucceeded(valid)
        setModal({ show: !valid, message: getIndividualLicenseCheckMessage(result) })
      })
    } else {
      setModal({ show: true, message: getIndividualLicenseCheckMessage() })
    }
  }

  /**
   * 「ポジションを契約する」ボタン
   */
  const handleNextButton = () => {
    navigate('/positionContract')
  }
  return (
    <>
      <Header title="証明書登録" />
      <main>
        <section className="mx-4 my-5">
          <h3 className="fw-bold">個人契約</h3>
          <div className="note">
            <div>※法人契約の方も個人の証明書登録が必要です</div>
            <div>※証明書の登録を行ってください。証明書の撮影が必要になります。</div>
            <div>※法人契約が非承認になった場合は個人の契約になります。</div>
            <div>※運転免許証の記載内容に変更のある場合は証明書登録ができません。</div>
          </div>
          <div className="note mt-3">
            <div>登録可能な証明書は以下となります。</div>
            <div>・パスポート</div>
            <div>・運転免許証</div>
            <div>・マイナンバーカード</div>
            <div>・在留カード</div>
          </div>
          <div className="mt-4">
            {(acceptedStatus || enterSucceeded) && (
              <Alert variant="success" className="mb-3">
                本人確認済み
              </Alert>
            )}
            <div>
              <Button variant="primary" className="w-100 py-4" onClick={handleStartAuthButton} disabled={!(acceptedStatus == null && !enterSucceeded)}>
                本人確認書類を撮影する
              </Button>
            </div>
          </div>
        </section>
        <section className="mx-4 my-5">
          <div className="pt-2">
            <Button variant="primary" className="w-100 py-4" onClick={handleNextButton} disabled={!(acceptedStatus == null && enterSucceeded)}>
              ポジションを契約する
            </Button>
          </div>
        </section>
      </main>
      <Footer className="mt-5" />

      <Modal show={modal.show} onHide={() => setModal({ show: false })}>
        <Modal.Body>{modal.message}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setModal({ show: false })}>
            閉じる
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default SceneComponent
